/* Charms watches collection (sections/charms-watches-collection.liquid).
   The page is otherwise plain markup: the only thing that needs a script is
   adding a watch to the cart without leaving the page. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cwc]');
  if (!root) return;

  var cfgEl = root.querySelector('[data-cwc-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = CFG.t || {};

  // Shopify's cart routes come back without the .js suffix on some markets
  function jsUrl(u) { return String(u || '').replace(/\.js$/, '') + '.js'; }
  var ADD_URL = jsUrl(CFG.add);

  function label(btn, text) {
    var span = btn.querySelector('span');
    if (span) span.textContent = text;
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cwc-add]') : null;
    if (!btn || btn.disabled) return;

    var id = parseInt(btn.getAttribute('data-cwc-add'), 10);
    if (!id) return;

    var original = T.add || 'Add to cart';
    btn.disabled = true;
    label(btn, T.busy || original);

    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function () {
        btn.classList.add('is-done');
        label(btn, btn.getAttribute('data-done') || T.added || 'Added');
        // let the theme's own cart drawer and counter know something changed
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        setTimeout(function () {
          btn.classList.remove('is-done');
          label(btn, original);
          btn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        console.warn('[Charms watches] add to cart', err);
        label(btn, original);
        btn.disabled = false;
      });
  });
})();
